import { render, staticRenderFns } from "./HearingAidEdit.vue?vue&type=template&id=55f2ffbe&"
import script from "./HearingAidEdit.vue?vue&type=script&lang=js&"
export * from "./HearingAidEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports